import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import PoweredBy from './PoweredBy';
import brand from '../brand/brand';
import { useContent } from '../i18n/LocaleProvider';
import { COOKIE_SETTINGS_EVENT } from './CookieConsent';

export default function Footer() {
  const { FOOTER_COLUMNS, LEGAL_LINKS, UI } = useContent();

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="u-container">
        <div style={{ marginBottom: 48 }}>
          <BrandLogo variant="reversed" height={44} />
        </div>

        <div className="site-footer__cols">
          {FOOTER_COLUMNS.map((column) => (
            <div key={column.heading}>
              <h3 className="site-footer__heading">{column.heading}</h3>
              <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {column.links.map((link) => (
                  <li key={`${column.heading}-${link.label}`}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="site-footer__legal">
          <div>
            <p className="t-mono" style={{ fontSize: 13, color: 'rgba(255,255,255,0.86)' }}>
              {brand.legalName} · Co. Reg. No. {brand.coRegNo}
            </p>
            <p className="t-mono" style={{ fontSize: 13, marginTop: 4 }}>
              {UI.common.listedOn} {brand.listing}
            </p>
            <p className="t-small" style={{ marginTop: 12 }}>
              © 2026 {brand.copyrightHolder}. {UI.common.rightsReserved}
            </p>
          </div>
          <nav aria-label="Legal">
            <ul
              style={{
                listStyle: 'none',
                margin: 0,
                padding: 0,
                display: 'flex',
                flexWrap: 'wrap',
                gap: '4px 20px',
              }}
            >
              {LEGAL_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="t-small">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  className="t-small site-footer__cookie-settings"
                  onClick={() => window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT))}
                  data-testid="footer-cookie-settings"
                >
                  {UI.common.cookieSettings}
                </button>
              </li>
            </ul>
          </nav>
        </div>

        <div className="site-footer__powered" data-testid="footer-powered-by">
          <PoweredBy variant="panel" />
        </div>
      </div>
    </footer>
  );
}
